
// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    body: $("body")
};

export function handleResponsiveMove() {
    const elements = document.querySelectorAll('[data-move-breakpoint]');

    const moveElements = () => {
        elements.forEach(el => {
            const breakpoint = parseInt(el.dataset.moveBreakpoint, 10) || 1200;
            const toMobile = document.querySelector(el.dataset.moveToMobile);
            const toDesktop = document.querySelector(el.dataset.moveToDesktop);
            const positionMobile = el.dataset.movePositionMobile || 'append';
            const positionDesktop = el.dataset.movePositionDesktop || 'append';
            const position = window.innerWidth <= breakpoint ? positionMobile : positionDesktop;

            if (!toMobile || !toDesktop) return;

            const isMobile = window.innerWidth <= breakpoint;

            const target = isMobile ? toMobile : toDesktop;
            const newPlacement = isMobile ? 'mobile' : 'desktop';

            if (el._currentPlacement !== newPlacement) {
                position === 'prepend'
                    ? target.prepend(el)
                    : target.appendChild(el);

                el._currentPlacement = newPlacement;
            }
        });
    };

    moveElements();
    window.addEventListener('resize', moveElements);
}

window.addEventListener('DOMContentLoaded', handleResponsiveMove);


// WEBPACK FOOTER //
// ./assets/js/modules/module.js